var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 894",
    d: "M1 11C1 16.5228 5.47715 21 11 21C13.8092 21 16.3479 19.8416 18.1644 17.9765C19.9191 16.1748 21 13.7136 21 11C21 5.47715 16.5228 1 11 1C8.25785 1 5.77349 2.10372 3.96692 3.89114C2.13497 5.70369 1 8.2193 1 11Z",
    stroke: "#EB4848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 6.36133V12.5",
    stroke: "#EB4848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 15.0088H11.0132",
    stroke: "#EB4848",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f4b1c572515a5968d9d814899aae171c.svg";
export { ForwardRef as ReactComponent };